import { render, staticRenderFns } from "./unwind.vue?vue&type=template&id=5de0d62c"
var script = {}
import style0 from "./unwind.vue?vue&type=style&index=0&id=5de0d62c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Title: require('/app/components/title.vue').default,Img: require('/app/components/img.vue').default})
